export const INITIAL_VALUES = {
  email: '',
  password: '',
};
